import { isPolygonClosed as c } from "@project-rouge/rg-core";
import { isLineInsideLine as l } from "./index14.js";
function u(r) {
  const t = [], o = r.slice();
  c(o) && o.pop();
  for (let e = 0; e < o.length; e++) {
    const n = o[e], s = e === 0 ? o[o.length - 1] : o[e - 1], i = e === o.length - 1 ? o[0] : o[e + 1];
    l([s, n], [n, i]) || l([n, i], [s, n]) || t.push(n);
  }
  return t.push(t[0]), t;
}
export {
  u as removePolygonSelfOverlaps
};
//# sourceMappingURL=index21.js.map
